<div
  style="background-image: url(../assets/img/about-background.webp); background-size: cover; background-repeat: no-repeat;">

  <div class="shippn-homepage-container container">
    <div class="row">
      <div style="text-align: left;margin-top: 100px;margin-bottom: 50px;" class="col-md-12">
        <div style="background-color: #222222;padding: 140px 80px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.41);">
          <h1 style="color: #fc7137;font-size: 28px;">About Us & Our Fast Shipping Service</h1>
          <hr style="border-color: #fc7137;margin-top: 10px;margin-bottom: 30px;">

          <p style="color: #ffffff;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
            Shippn is a trusted community marketplace for people to be able to shop from anywhere in the world. Shippn
            hosts help shoppers from all around the world to have a local address in every country and shop conveniently
            like there are no borders. <br>
            <br>
            With Shippn, everyone can shop online from more than {{hostCountriesCount}} countries in the world and receive their items with
            express delivery in 1-5 days after our hosts receive their packages regardless of where they live. <br>
            <br>
            People can dive into shopping action in U.S.A. to catch Black Friday deals or Christmas specials.
            They can buy a classy watch from Switzerland or handmade rug from Turkey with Shippn. <br>
            <br>
            Shippn connects people to shop from various countries, at great prices, in more than {{hostCountriesCount}} countries. And with
            world-class customer service and a growing community of users, Shippn is the easiest way for people to
            monetize their extra space and open it to an audience of millions. <br>
            <br>
            Shippn works with worldwide trusted logistics partners like DHL, TNT, UPS, FEDEX and picks the best partner
            to deliver to members’ door fast and secure.
          </p>
        </div>
      </div>
    </div>
  </div>

</div>

<div style="background-color: #222222;padding-bottom: 45px;">
  <div class="shippn-homepage-container container">
    <div class="row">
      <div style="text-align: center;margin-top: 45px;margin-bottom: 25px;" class="col-md-12">
        <h6 style="color: #ffffff;font-size: 28px;">TEAM</h6>
        <p style="color: #ffffff;font-size: 22px;margin-top: 20px;margin-bottom: 20px;">
          We want to make the world more accessible for everyone!
        </p>
      </div>
    </div>
    <div class="row">
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/levent-ilhaner.jpg" alt="Shippn Team Levent Ilhaner">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Levent
          Ilhaner</h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Co-Founder</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/seyfi-erol.jpg" alt="Shippn Team Seyfi Erol">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Seyfi Erol
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Co-Founder</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/enes-guren.jfif" alt="Shippn Team Enes Guren">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Enes Guren
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Co-Founder</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/DuhanIcoz.jpg" alt="Shippn Team Duhan Icoz">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Duhan Icoz
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">CEO</h6>
      </div>

      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/cem-caka.jfif" alt="Shippn Team Cem Caka">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Cem Caka</h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Head Of Product</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/MEHMET_YALCIN.jpg" alt="Shippn Team Mehmet Yalcin">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Mehmet Yalcin</h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Sr. BE Developer</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/Baris_Cesim.webp" alt="Shippn Team Baris Cesim">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Baris Cesim</h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Sr. FE Developer</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/UmutGunduz.jpg" alt="Umut Gunduz">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Umut Gunduz</h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Sr. Graphic Designer</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/OrhunOzcan.jpeg" alt="Shippn Team Orhun Ozcan">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Orhun Ozcan
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Operations Manager</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/TunaGozkaya.jpeg" alt="Shippn Team Tuna Gozkaya">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Tuna Gozkaya
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Logistics & Vendors  Executive</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/Emre_Kirdi.jpeg" alt="Shippn Team Emre Kirdi">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Emre Kirdi
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Global Host Manager</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/EylulAkkus.jpeg" alt="Shippn Team Eylul Akkus">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Eylul Akkus
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Operations Specialist</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/mert_ertugrul_tan .webp"
          alt="Shippn Team Mert Tan">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Mert Tan </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Operations Specialist</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/OzgunOcar.jpeg" alt="Shippn Team Ozgun Ocar">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Ozgun Ocar
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Operations Specialist</h6>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/EgeIsiksoy.jpeg" alt="Shippn Team Ege Isiksoy">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Ege Isiksoy
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Asst. Operations Specialist</h6>
      </div>
      
      <div style="text-align: center;margin-top: 20px;" class="col-6 col-sm-6 col-md-3 col-lg-3">
        <img class="about-team-img" src="../../../assets/img/team/NijatAhmadzada.jpeg" alt="Shippn Team Nijat Ahmadzada">
        <h6 style="color: #ffffff;font-size: 18px;margin-top: 20px;margin-bottom: 10px;font-weight: bold;"
          translate="no">Nijat Ahmadzada
        </h6>
        <h6 style="color: #ffffff;font-size: 18px;margin-bottom: 10px;font-weight: 300;">Asst. Operations Specialist</h6>
      </div>

    </div>
  </div>
</div>